export default {
  data() {
    return {
      isAuthenticated: false,
      userProfile: {
        avatar: '',
        country: '',
        custom_name: '',
        id: '',
        online: false,
        rank: { name: 'player', expiresAt: 0 },
        session: {
          team: null,
          server: null
        },
        status: {
          banned: false,
          reason: '',
          expire: 0
        },
        steamid64: '',
        username: ''
      },
      authToken: localStorage.getItem('authToken')
    }
  },
  methods: {
    checkAuth() {
      return this.isAuthenticated
    },
    logout() {
      localStorage.removeItem('authToken');
      this.authToken = ''
      this.isAuthenticated = false
      this.userProfile = null
      this.$router.push('/')
    },
    refresh() {
      axios.get(`https://api-staging.zero1.id/api/v3/players/@me`, { headers: { 'Authorization': this.authToken } }).then((res) => {
        this.isAuthenticated = true
        this.userProfile = res.data;
      }).catch((err) => {
        this.isAuthenticated = false
        this.userProfile = null
      })
    },
    setAuthTicket(ticket) {
      this.authTicket = ticket
    }
  },
  created() {
    document.body.style.zoom = "90%";
    this.authToken = localStorage.getItem('authToken');
    if (this.authToken) {
      this.isAuthenticated = false
      this.refresh()
    }
    console.log(`created ${this.authToken}`)
  },
  watch: {
    userProfile: function(userProfile) {
      if (userProfile) {
        window.gtag('set', {'user_id': userProfile.id})
      }
    },
    authToken: function(authToken) {
      if (authToken) {
        localStorage.setItem('authToken', authToken);
        this.isAuthenticated = false
        this.refresh()
      }
    },
    authTicket: function(authTicket) {
      localStorage.setItem('authTicket', authTicket)
    }
  }
}
